import { render, staticRenderFns } from "./svalves.vue?vue&type=template&id=40fd6896&scoped=true"
import script from "./svalves.vue?vue&type=script&lang=js"
export * from "./svalves.vue?vue&type=script&lang=js"
import style0 from "./svalves.vue?vue&type=style&index=0&id=40fd6896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fd6896",
  null
  
)

export default component.exports